module.exports = __webpack_public_path__ + "static/media/steps_to_the_garden_small.37da0588.jpg";